/**
 * Reaktiver Blick auf die Dienst-Registry (services.ts) — für UI-Gates:
 * Mikrofon-Knopf, Goals-Badge, Anhang-Upload verschwinden LEISE, wenn die
 * Instanz den Dienst mit `null` deklariert (Vertrag 77eb0c9, Post #4701).
 *
 * Startwert ist die aktuelle Auflösung (Betreiber-Default, solange die
 * Instanz-Map nicht geladen ist) — für den gesamten Bestand ist das ohnehin
 * der Endwert. Die Map lädt useInstanceMode mit demselben /api/version-Abruf.
 */
import { useEffect, useState } from 'react';
import { serviceOrigin, subscribeServiceOrigins, type ServiceName } from '../lib/services';
import { useInstanceMode } from './useInstanceMode';

export function useServiceOrigin(name: ServiceName): string | null {
  // useInstanceMode stößt den /api/version-Abruf an (Modul-Cache, einmalig).
  useInstanceMode();
  const [origin, setOrigin] = useState<string | null>(() => serviceOrigin(name));
  useEffect(() => {
    setOrigin(serviceOrigin(name));
    return subscribeServiceOrigins(() => setOrigin(serviceOrigin(name)));
  }, [name]);
  return origin;
}

/** `false` genau dann, wenn die Instanz den Dienst mit `null` deklariert. */
export function useServiceAvailable(name: ServiceName): boolean {
  return useServiceOrigin(name) !== null;
}
